import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";

class OtcWithdrawalComponent extends Component {
  state = {
    fields: [[
      {
        name: "currency",
        label: "Currency",
        fieldType: "input",
        disabled: true,
        flexGrow: 5,
      }, {
        name: "availableBalance",
        label: "OTC Balance",
        fieldType: "input",
        disabled: true,
        formatValue: true,
        flexGrow: 10,
        rightAlign: true,
      }, {
        name: "walletId",
        label: "Wallet",
        fieldType: "select",
        disabled: false,
        flexGrow: 10,
        getOptions: () => this.props.getOptionsFromState("otcWallets"),
        items: "otcWallets",
      }, {
        fieldType: "empty",
        flexGrow: 10
      }, {
        name: "balanceToSettle",
        label: "Amount to Withdraw",
        fieldType: "input",
        updateRequestedField: true,
        flexGrow: 10,
        rightAlign: true,
      }, {
        name: "checkBox",
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onAutoFunction(index, "availableBalance", "balanceToSettle", "otcWithdrawalForm"),
        alignSelf: "end",
        flexGrow: 0,
      }
    ], [
      {
        name: "withdrawalFee",
        label: "Withdrawal Fee",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 5,
      },
      {
        name: "confirmationLink",
        label: "Validation Link",
        fieldType: "input",
        flexGrow: 10,
      },
      {
        name: "notes",
        label: "Notes",
        fieldType: "textarea",
        flexGrow: 10,
      }, { fieldType: "empty", flexGrow: 20 },
      {
        name: "checkBox",
        empty: true,
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onAutoFunction(index),
        alignSelf: "end",
        flexGrow: 0,
      }
    ],
    [
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      { fieldType: "button" },
    ]]
  };

  componentDidMount() {
    const { getOptionsFromState } = this.props;
    if (getOptionsFromState) {
      this.setState({
        getOptionsFromParentState: getOptionsFromState,
      });
    }
  }

  onSaveDataEntries = () => {
    const { savedData, form } = this.props;
    const isValid = form.map((elem) => elem.isFormValid()).every(Boolean);

    if (isValid) {
      form.map(elem => elem.balanceToSettle = elem.balanceToSettle ? parseFloat(elem.balanceToSettle).toFixed(2) : elem.balanceToSettle);
      const otcBalanceForm = form[0];
      const otcInfoForm = form[1];
      const data = {
        merchantId: savedData.merchant,
        currency: otcBalanceForm.currency,
        availableBalance: otcBalanceForm.availableBalance,
        walletId: otcBalanceForm.walletId,
        balanceToSettle: otcBalanceForm.balanceToSettle,
        validationLink: otcInfoForm.confirmationLink,
        withdrawalFee: otcInfoForm.withdrawalFee,
        notes: otcInfoForm.notes
      };

      crudActions.post(`v1/otc/balances`, data,)
        .then(() => {
          this.afterSuccessSave("Operation successful.");
        }).catch((err) => {
          this.errorUpdate(err ? err.message : '');
        });
    } else {
      const newState = { otcWithdrawalForm: form };
      this.updateState(newState);
    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    
    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);
    
    if (isFormValid) {
      this.props.loadOtcWallets();
      const newState =  this.populateOtcBalanceForm();
      Object.assign(newState, {
        showSecondPanel: true,
        loadingDataInput: false,
        lockButton: false,
      });
      this.updateState(newState);
    }
  };

  populateOtcBalanceForm = () => {
    const { controls } = this.props;
    const otcBalances = this.state.getOptionsFromParentState("otcBalances");
    const stateForUpdate = {};
    const otcWithdrawalForm = [];

    const otcBalanceForm = this.getOtcBalanceForm(controls, otcBalances);
    const infoForm = this.getInfoForm();
    otcWithdrawalForm.push(otcBalanceForm, infoForm);

    this.updateField("OTC_WITHDRAWAL", this.state.fields);

    Object.assign(stateForUpdate,  {
      otcWithdrawalForm: otcWithdrawalForm
    });
    return stateForUpdate;
  };

  getOtcBalanceForm = (controls, otcBalances) => {
    const currency = controls.currency;
    return new Form(
      {
        currency: currency,
        availableBalance: otcBalances[currency],
        walletId: "",
        balanceToSettle: "",
      },
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "walletId",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 1,
            required: true,
          },
        }
      ]
    );
  };
  
  getInfoForm = () => {
    return new Form({
      withdrawalFee: 0.00,
      confirmationLink: "",
      notes: "",
    },
    [
      {
        name: "withdrawalFee",
        type: "isNumber",
        rules: {
          required: true,
        },
      },
      {
        name: "confirmationLink",
        type: "isUrl",
        rules: {
          required: true,
        },
      },
      {
        name: "notes",
        type: "isString"
      }
    ]);
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message, typeAlert) => {
    this.props.showErrorAlert(message, typeAlert);
  };

  render() {
    return <></>;
  };
}

export default OtcWithdrawalComponent;